(() => {
  const dialog = document.getElementById('SistersLoveNewsletterPopup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const seenKey = 'sl-newsletter-seen-v1';
  const pendingKey = 'sl-newsletter-pending-v1';
  const subscribedKey = 'sl-newsletter-subscribed-v1';
  const read = (key) => { try { return sessionStorage.getItem(key); } catch { return '1'; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
  const form = document.getElementById('SistersLoveNewsletterForm');
  let previousFocus;
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    write(seenKey, '1');
    dialog.showModal();
  };
  dialog.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  form?.addEventListener('submit', () => { if (form.checkValidity()) write(pendingKey, '1'); });
  const result = dialog.querySelector('[data-newsletter-result]');
  if (result && read(pendingKey) === '1') {
    write(pendingKey, '0');
    if (result.dataset.newsletterResult === 'success') write(subscribedKey, '1');
    open();
    return;
  }
  if (read(seenKey) || read(subscribedKey)) return;
  const started = Date.now();
  const tryOpen = () => {
    if (Date.now() - started > 30000 || read(seenKey)) return;
    const busy = document.visibilityState !== 'visible' ||
      Array.from(document.querySelectorAll('dialog[open], cart-drawer.active, details[open] .menu-drawer, .shopify-pc__banner__dialog')).some(element => element.getClientRects().length > 0);
    if (busy) { setTimeout(tryOpen, 1500); return; }
    open();
  };
  setTimeout(tryOpen, 5000);
})();
